exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ny-sirs {\n  height: 10px;\n}\n.beds-input-current input::placeholder {\n  color: #979797 !important;\n  margin-top: 5vh;\n}\n.ny-sirs-first-row {\n  margin-top: 2vh;\n}\n.ny-sirs-eligibility-toggle {\n  margin-top: 4.5vh;\n  margin-left: 15%;\n}\ninput.sirs-export-disabled {\n  background-color: #f2f2f2 !important;\n  border-color: #ddd;\n}\n.sirsAutoExportGrid .sirsRow {\n  margin: 20px 0px;\n  height: 75px;\n}\n.sirsAutoExportGrid .times-row {\n  margin-right: 40px;\n  height: 75px;\n  display: table-cell;\n  vertical-align: middle;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/nysirsexport/nysirsexport.less
// module id = 3692
// module chunks = 0